import { useParams } from 'react-router-dom';

import TaskDetail from '~/components/maud/tasks/TaskDetail';

const TaskDetailRoute = () => {
  const { taskId } = useParams<{ taskId: string }>();
  return <TaskDetail taskId={taskId} />;
};

export default TaskDetailRoute;
